import * as types from './mutationTypes'
// import { loginByCode } from '../api/wechatAuth'
import {
    saveToken,
    saveLoginStatus,
    saveUserInfo,
    removeToken,
    removeUserInfo,
} from '../utils/cache'
// import router from "../router/index";
import store from "./index";

function saveInfo (commit, rs) {
    let userInfo = {}
    let accessToken = {}
    userInfo['userId'] = rs.userId;
    userInfo['openId'] = rs.openId;
    userInfo['username'] = rs.username;

    accessToken['access_token'] = rs.access_token;
    accessToken['refresh_token'] = rs.refresh_token;
    accessToken['refresh_overtime'] = rs.refresh_overtime;
    accessToken['access_overtime'] = rs.access_overtime;

    commit(types.SET_USERINFO, saveUserInfo(userInfo))
    commit(types.SET_TOKEN, saveToken(accessToken))
}

//登录相关
export const loginWechatAuth = async function ({ commit, state }, query) {
    let data = {
        code: query.code,
        openId: query.openId,
        appId: process.env.VUE_APP_WECHAT_APPID
    }

    return new Promise(((resolve, reject) => {
        // loginByCode(data).then(res => {
        //   if (res){
        //     let data = res.data
        //     if (data['success']){
        //       if ( data['content']){
        //         saveInfo(commit, data.content)
        //       }
        //     }
        //     else{
        //     }
        //   }
        //   resolve(res)
        // }).catch(error => {
        //   reject(error)
        // })
    }))
}


//设置状态
export const setLoginStatus = async function ({ commit, state }, query) {
    if (query == 0 || query == 1) { //登录失败
        //上线打开注释，本地调试注释掉
        commit(types.SET_TOKEN, null) //清空state的token
        await removeToken()
        // await removeUserInfo()
    }
    commit(types.SET_LOGIN_STATUS, saveLoginStatus(query))
}

//保存用户个人信息
export const setUserInfo = function ({ commit, state }, query) {
    commit(types.SET_USERINFO, saveUserInfo(query))
}

export const setShowLeftStatus = function ({ commit, state }, query) {
    commit(types.SET_SHOWLEFTSTATUS, query)
}


// WEBPACK FOOTER //
// ./src/store/actions.js